import { render, staticRenderFns } from "./MyInvigilate.vue?vue&type=template&id=0a0818de&scoped=true&"
import script from "./MyInvigilate.vue?vue&type=script&lang=js&"
export * from "./MyInvigilate.vue?vue&type=script&lang=js&"
import style0 from "./MyInvigilate.vue?vue&type=style&index=0&id=0a0818de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0818de",
  null
  
)

export default component.exports